import React from 'react';
import styled from 'styled-components';
import {Donut} from '../../../../StyledUtils';

export const PhoneContainer = styled.div`
  position: relative;
  top: 4px;
  left: 4px;
  width: 56px;
  height: 56px;
  background-color: #4a8af4;
  border-radius: 50%;
  overflow: hidden;
`;

export const PhoneImg = styled.div`
  width: 32px;
  height: 60px;
  background-image: url(/images/mobile/mobile-phone.svg);
  background-size: contain;
  transform: translate(12px, 12px);
`;

export const StyledDonut = styled(Donut)`
  width: 16px;
  height: 16px;
  transform: translate(20px, -32px);
`;

export const Title = styled.div`
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 22px;
  max-width: 150px;
  text-align: center;
`;

export const Line = styled.div`
  align-self: flex-start;
  font-size: 12px;
  font-weight: normal;
  margin-bottom: 18px;
  max-width: 280px;
`;

export const GoogleLink = styled.a`
  background-image: url(/images/mobile/stores/google-short-color.svg);
  width: 105px;
  height: 30px;
  margin-right: 8px;
`;

export const AppleLink = styled.a`
  background-image: url(/images/mobile/stores/apple-short-color.svg);
  width: 105px;
  height: 30px;
`;
